import React, { useState } from 'react';
import { Content, Row, Col, Title, Button, Pagination, Text } from 'components';
import { SideMenu } from '../components';
import { DatePicker } from 'antd';
import moment from 'moment';

const PAGE_NUM = [
  { label: '5개씩', value: 5 },
  { label: '10개씩', value: 10 },
  { label: '15개씩', value: 15 },
  { label: '20개씩', value: 20 },
];

const MypageEventPresenter = ({ screenSize }) => {
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    paginationButton: {
      color: 'var(--black-color)',
      width: 28,
      height: 28,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    button: {
      width: '25%',
      borderRadius: '0',
      border: '1px solid var(--light-gray-color)',
      backgroundColor: '#fff',
      color: 'var(--light-gray-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: 16,
      cursor: 'pointer',
    },
    activeButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
    },

    title: {
      fontSize: 16,
      color: 'var(--black-color)',
      lineHeight: '180%',
    },
    paginationButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
      width: 48,
      height: 48,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    },
  };

  const eventList = [
    {
      status: '이벤트 진행중',
      event_name: 'JMCOFFEE 공식 앱 출시기념 다운로드 이벤트',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
    {
      status: '이벤트 종료',
      event_name: '재방문 커피 100% 증정',
      start_date: new Date(),
      end_date: new Date(),
    },
  ];

  /* 개월 선택 버튼 */
  const [selected, setSelected] = useState('1개월');

  const handleClick = (period) => {
    setSelected(period);
  };

  const { RangePicker } = DatePicker;

  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const [pageSize, setPageSize] = useState(10); // 페이지 크기 상태

  // 페이지에 보여질 수
  const [pageCount, setPageCount] = React.useState(PAGE_NUM[0].value);

  // 페이지네이션 적용
  const paginatedList = eventList.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} xl={2}></Col>
        <Col x={0} md={6} xl={4}>
          <SideMenu />
        </Col>
        <Col x={24} md={16} xl={16}>
          <Content
            maxWidth={'100%'}
            padding={
              screenSize >= 1200
                ? '0 0 0 95px'
                : screenSize >= 768
                ? '0 0 0 20px'
                : '0'
            }
          >
            {/* 주문내역 */}
            <Content maxWidth={'100%'} padding={0}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Title
                  style={{
                    ...styles.titleLayout,
                    fontSize:
                      screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                    fontWeight: 700,
                  }}
                >
                  이벤트 참여 내역
                </Title>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '32px 0',
                    borderBottom: '1px solid var(--black-color)',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      width: '51.4%',
                      height: 48,
                    }}
                  >
                    <div style={styles.buttonGroup}>
                      {['1개월', '3개월', '6개월', '1년'].map((period) => (
                        <button
                          key={period}
                          style={{
                            ...styles.button,
                            ...(selected === period ? styles.activeButton : {}),
                          }}
                          onClick={() => handleClick(period)}
                        >
                          {period}
                        </button>
                      ))}
                    </div>
                  </div>
                  <RangePicker
                    style={{
                      width: '29.6%',
                      height: 48,
                      border: '1px solid var(--light-gray-color)',
                    }}
                  />
                  <Button
                    style={{
                      width: '14.4%',
                      borderRadius: '0',
                      fontWeight: 700,
                      fontSize: 16,
                      backgroundColor: 'var(--white-color)',
                      color: 'var(--black-color)',
                      border: '1px solid var(--black-color)',
                    }}
                  >
                    조회
                  </Button>
                </div>
              </div>
            </Content>

            <Content maxWidth={'100%'} padding={0}>
              {/* 포인트 목록 */}
              <div>
                {paginatedList.length > 0 ? (
                  paginatedList.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        borderBottom: '1px solid #ddd',
                        padding: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '32px 0',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '60%',
                        }}
                      >
                        <Text
                          size={16}
                          style={{
                            width: '13.3%',
                            color:
                              item.status === '이벤트 진행중'
                                ? 'var(--red-secondary-color)'
                                : item.status === '이벤트 종료'
                                ? 'var(--dark-gray-color)'
                                : 'inherit',
                            fontWeight: 700,
                          }}
                        >
                          {item.status}
                        </Text>
                        <Text size={16} style={{ width: '75.5%' }}>
                          {item.event_name}
                        </Text>
                        <div
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <Text size={16}>{item.product_name}</Text>
                          <Text size={14} color={'var(--dark-gray-color)'}>
                            {item.product_data}
                          </Text>
                        </div>
                      </div>
                      <div
                        size={16}
                        weight={700}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '34%',
                        }}
                      >
                        <Text size={16} style={{ width: '53.5%' }}>
                          {moment(item.start_date).format('YYYY.MM.DD')}
                          <span>~</span>
                          {moment(item.end_date).format('YYYY.MM.DD')}
                        </Text>
                        <div
                          style={{
                            width: '27%',
                            textAlign: 'center',
                          }}
                        >
                          {item.status === '이벤트 진행중' ? (
                            <span>-</span>
                          ) : (
                            <Button
                              style={{
                                borderRadius: '2px',
                                backgroundColor: 'transparent',
                                color: 'var(--black-color)',
                                border: '1px solid var(--black-color)',
                                fontSize: 14,
                                fontWeight: 700,
                                cursor: 'pointer',
                              }}
                            >
                              당첨자 발표
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    포인트 내역이 없습니다.
                  </div>
                )}
              </div>

              {/* 페이지네이션 */}
              <div style={{ marginTop: 100 }}>
                <Pagination
                  total={eventList.length}
                  pageSize={pageSize}
                  current={currentPage}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger
                  onShowSizeChange={(current, size) => {
                    setPageSize(size);
                    setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                  }}
                  showPage={5}
                  buttonStyle={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: '#999999',
                    background: 'none',
                    width: 28,
                    height: 28,
                  }}
                  isButton={true}
                  activeStyle={{
                    color: `var(--black-color) !important`,
                    borderBottom: '2px solid #111111',
                  }}
                  hoverStyle={{
                    color: `var(--black-color) !important`,
                  }}
                  navStyle={{
                    border: '1px solid var(--black-color)',
                  }}
                  isLatestButton={true}
                />
              </div>
            </Content>
          </Content>
        </Col>
        <Col x={0} md={1} xl={2}></Col>
      </Row>
    </Content>
  );
};

export default MypageEventPresenter;
